// core version + navigation, pagination modules:
import Swiper, {
  Lazy, Navigation, Pagination, Autoplay,
} from 'swiper';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Lazy, Autoplay]);

const mySwiper = new Swiper('.js-main-slider', {
  loop: document.querySelectorAll('.js-main-slider .swiper-slide').length > 1,
  lazy: true,
  speed: 500,
  slidesPerView: 1,
  autoplay: {
    delay: 7000,
  },
  navigation: {
    nextEl: '.swiper-button-next-main',
    prevEl: '.swiper-button-prev-main',
  },
});

document.querySelectorAll('.js-products-slider').forEach((item) => {
  new Swiper(item, {
    slidesPerGroup: 1,
    loop: true,
    loopFillGroupWithBlank: true,
    lazy: {
      loadPrevNext: true,
    },
    preloadImages: false,
    slidesPerView: 1,
    spaceBetween: 0,
    loopedSlides: 1,
    navigation: {
      nextEl: '.swiper-button-next-product',
      prevEl: '.swiper-button-prev-product',
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 0,
        loopedSlides: 2,
        slidesPerGroup: 2,
      },
    },
  });
});

const adviceSlider = new Swiper('.js-advice-slider', {
  slidesPerView: 1,
  spaceBetween: 0,
  slidesPerGroup: 1,
  loop: true,
  lazy: true,
  loopFillGroupWithBlank: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
